<script>
export default {
  name: 'DotsInlineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#fff',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 21 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="1.5" r="1.5" :fill="color" />
    <circle cx="7.5" cy="1.5" r="1.5" :fill="color" fill-opacity="0.8" />
    <circle cx="13.5" cy="1.5" r="1.5" :fill="color" fill-opacity="0.7" />
    <circle cx="19.5" cy="1.5" r="1.5" :fill="color" fill-opacity="0.5" />
  </svg>
</template>
